import type { ChatRoomType } from "@/lib/humhub-api/types";

const chatQueryRoots = new Set([
  "chatRooms",
  "chatRoomsInfinite",
  "chatRoomsUnreadTotals",
  "chatRoom",
  "chatRoomMembers",
  "chatRoomEntries",
  "chatMentionUsers",
]);

export const chatKeys = {
  rooms: () => ["chatRooms"] as const,
  roomsInfinitePrefix: () => ["chatRoomsInfinite"] as const,
  roomsInfinite: (params: {
    perPage: number;
    type: ChatRoomType;
    refreshKey: number;
  }) => ["chatRoomsInfinite", params] as const,
  unreadTotalsPrefix: () => ["chatRoomsUnreadTotals"] as const,
  unreadTotalsAll: () => ["chatRoomsUnreadTotals", "all"] as const,
  unreadTotalsByType: (type: ChatRoomType) =>
    ["chatRoomsUnreadTotals", { type }] as const,
  room: (id: string | number) => ["chatRoom", id] as const,
  roomMembers: (id: string | number | null) => ["chatRoomMembers", id] as const,
  roomEntries: (id: string | number | null) => ["chatRoomEntries", id] as const,
  mentionUsers: (
    keyword?: string,
    messageId?: string | number,
    limit = 5,
    page = 1,
  ) => ["chatMentionUsers", keyword, messageId, limit, page] as const,
  isChatRelatedKey: (queryKey: readonly unknown[]): boolean => {
    const key = queryKey[0];
    return typeof key === "string" && chatQueryRoots.has(key);
  },
  isExistingByParticipantsKey: (queryKey: readonly unknown[]): boolean => {
    return queryKey[0] === "chatExistingByParticipants";
  },
  shouldInvalidateForVisit: (queryKey: readonly unknown[]): boolean => {
    const key = queryKey[0];
    return key === "chatRoomsInfinite" || key === "chatRoomsUnreadTotals";
  },
  shouldInvalidateForRoom: (
    queryKey: readonly unknown[],
    chatRoomId?: string,
  ): boolean => {
    if (!chatKeys.isChatRelatedKey(queryKey)) {
      return false;
    }
    const key = queryKey[0];
    if (
      key === "chatRooms" ||
      key === "chatRoomsUnreadTotals" ||
      key === "chatRoomsInfinite"
    ) {
      return true;
    }
    if (!chatRoomId) {
      return true;
    }
    if (queryKey[1] && queryKey[1] !== chatRoomId) {
      return false;
    }
    return true;
  },
};
